module.exports = __webpack_public_path__ + "img/top1.e6487dfc.png";